import React, { useEffect, useState } from "react";
import { dispatch } from "store";
import StockListCommons from "../StockListCommons";
import {
  fillingPersonStockSelector,
  getFillingPersonStockThunk,
  resetFillingPersonStockTransactionStatus,
} from "store/reducers/inventory/stock/fillingPersonStockSlice";
import { useSelector } from "react-redux";
import TransferFillingPersonStock from "./menu/TransferFillingPersonStock";
import ReturnFillingPersonStock from "./menu/ReturnFillingPersonStock";
import { Box, Button, Stack } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import { getFillingPersonThunk } from "store/reducers/accounts";
import { useNavigate } from "react-router-dom";
import RemoveFillingPersonStock from "./menu/RemoveFillingPersonStock";

const FillingPersonStockList = () => {
  useEffect(() => {
    dispatch(getFillingPersonStockThunk());
  }, []);
  const navigate = useNavigate();
  const roles = useSelector((state) => state.auth.user.roles);
  const items = useSelector(fillingPersonStockSelector.selectAll);
  const [returnOpen, setReturnOpen] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [stock, setStock] = useState(null);

  const openMainStockReturn = (item) => {
    setReturnOpen(true);
    setStock(item);
    dispatch(resetFillingPersonStockTransactionStatus())
  };
  const openTransfer = (item) => {
    setTransferOpen(true);
    setStock(item);
    dispatch(resetFillingPersonStockTransactionStatus())
  };
  const openRemove = (item) => {
    setRemoveOpen(true);
    setStock(item);
    // dispatch(resetFillingPersonStockTransactionStatus())
    
  };
  useEffect(() => {
    dispatch(getFillingPersonThunk());
  }, []);
  const fillingPersons = useSelector((state) => state.accounts.fillingPersons);
  const [fillingPerson, setFillingPerson] = useState(null);
  useEffect(() => {
    if (fillingPerson) {
      dispatch(getFillingPersonStockThunk(fillingPerson.profile.id));
    }
  }, [fillingPerson]);

  return (
    <Box padding={3}>
      <Stack marginBottom={2} direction="row" justifyContent="space-between">
        {roles.any([
          "super_admin",
          "admin",
          "machine_admin",
          "location_admin",
        ]) && (
          <Box width={300}>
            <AutoCompleteList
              items={fillingPersons}
              name="username"
              label="Filter filling person"
              setValue={setFillingPerson}
              value={fillingPerson}
            />
          </Box>
        )}
        <Button
          variant="outlined"
          onClick={() => {
            navigate(
              fillingPerson ? `logs?fillingPerson=${fillingPerson.id}` : "logs"
            );
          }}
        >
          View transaction logs
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            navigate(
              fillingPerson
                ? `history?fillingPerson=${fillingPerson.id}`
                : "history"
            );
          }}
        >
          View stock history
        </Button>
      </Stack>
      <StockListCommons
        items={items}
        openStockReturn={openMainStockReturn}
        openTransfer={openTransfer}
        stock={stock}
        returnOpen={returnOpen}
        removeOpen={removeOpen}
        openRemove = {openRemove}
        transferOpen={transferOpen}
        setReturnOpen={setReturnOpen}
        setRemoveOpen={setRemoveOpen}
        setTransferOpen={setTransferOpen}
        ReturnStock={ReturnFillingPersonStock}
        TransferStock={TransferFillingPersonStock}
        hasEditPermissions={roles.includes("filling_person")}
        RemoveStock={RemoveFillingPersonStock}
        disableTransfer={true}
        disableReturn={false}
      />
    </Box>
  );
};

export default FillingPersonStockList;
